<div class="accepted-promocode">
  <div class="d-flex align-v-center mr-10">
    <i class="icon-promo-code is-default ic-secondary m-10"></i>

    <div>
      <div class="text-body mb-5">
        {{ subscription.promoCode.code }}
      </div>
      <div class="text-description c-primary">
        {{ subscription.promoCode | call:'getLabel' }}
      </div>
    </div>
  </div>

  @if (!subscription.id) {
    {{ subscription.id }}
    <button class="btn icon-close" (click)="removed.emit()"></button>
  }
</div>
